// Píxel de ChatGPT Ads (OpenAI) en el alta (21/10/2026). El SDK `oaiq` se carga en
// public/index.html con el MISMO pixelId que la landing. La landing deja la cookie del clic
// (`__oppref`) en el dominio raíz (.conextcrm.es: el SDK prueba el dominio registrable), así que
// aquí la lee sola y el alta queda atribuida al anuncio de ChatGPT que trajo a la persona.
//
// `lead_created` es el evento estándar al que optimizan las campañas de ChatGPT (también la de
// autoescuelas, con el grupo «Profesores ES» que lleva al alta ?plan=profesor). Nunca debe romper
// el alta: si un bloqueador impide cargar el SDK, `window.oaiq` no existe y no se hace nada.

export function trackOpenAiLeadCreated({ vertical, plan, eventId } = {}) {
  try {
    if (typeof window === "undefined" || typeof window.oaiq !== "function") return false;
    const data = {};
    if (vertical) data.vertical = String(vertical);
    if (plan) data.plan = String(plan);
    if (eventId) window.oaiq("measure", "lead_created", data, { event_id: String(eventId) });
    else window.oaiq("measure", "lead_created", data);
    return true;
  } catch {
    return false;
  }
}
